import { styled } from '@mui/styles';
import Box from '@mui/material/Box';
import { colorPalette } from '../../colorPalette';
import '@mui/system';
export const StyledLabel = styled(Box)(({ checked, margins, }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '16px 16px 16px 7px',
    boxSizing: 'border-box',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: (margins === null || margins === void 0 ? void 0 : margins.marginTop) ? `${margins.marginTop}px` : 0,
    marginBottom: (margins === null || margins === void 0 ? void 0 : margins.marginBottom) ? `${margins.marginBottom}px` : 0,
    background: checked ? colorPalette.gray100 : colorPalette.white,
    border: checked ? `1px solid ${colorPalette.gray1000}` : `1px solid ${colorPalette.gray300}`,
}));
